export default "__VITE_PUBLIC_ASSET__43f1fbca__"